export const fields = [
  {
    type: 'QCheckbox',
    has_help: true,
    help_tooltip_translation_key: 'auto_generate_tab_index_help',
    name: 'auto_generate_tab_index',
    translation_key: 'auto_generate_tab_index',
    help_id: 'auto_generate_tab_index',
    value: false,
  },
  {
    type: 'QCheckbox',
    has_help: true,
    help_tooltip_translation_key: 'disable_extraction_confirmation_box_help',
    name: 'disable_extraction_confirmation_box',
    translation_key: 'disable_extraction_confirmation_box',
    help_id: 'diable-extraction-confirmation-box',
    value: false,
  },
  {
    type: 'QCheckbox',
    has_help: true,
    help_tooltip_translation_key: 'help_validation_time_spent_counter',
    name: 'validation_time_spent_counter',
    translation_key: 'validation_time_spent_counter',
    help_id: 'time-spent-settings',
    value: false,
  },
];
